import { useLanguage } from "../context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const ProjectsSection = ({ projects }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="projects-section" className="py-16 md:py-24 border-t border-slate-200">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-800 mb-12 animate-fade-in-up">
        {t('Prosjekter', 'Projects')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {projects.map((project, index) => (
          <a
            key={index}
            href={project.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white border border-slate-200 rounded-lg p-6 md:p-8
              hover:border-sky-400 hover:shadow-lg transition-all duration-300 ease-out
              animate-fade-in-up flex flex-col gap-3"
            style={{ animationDelay: `${(index + 1) * 100}ms` }}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-semibold text-slate-900">{project.name}</h3>
              <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-sky-500 transition-colors duration-300" />
            </div>
            <p className="text-slate-600 leading-relaxed">
              {getLocalizedText(project.description)}
            </p>
            {project.tag && (
              <span className="self-start text-xs font-medium text-sky-600 bg-sky-50 px-2 py-1 rounded">
                {project.tag}
              </span>
            )}
          </a>
        ))}
      </div>
    </section>
  );
};

export default ProjectsSection;
